export const getConciliationIdFromUrl = (url: string) => {
  if (!url) return

  let pathWithId
  let idStr

  const parts = url.split("/")
  if (parts?.length) {
    if (url.includes("?")) {
      pathWithId = parts?.find(str => str.includes("?"))

      idStr = pathWithId?.split("?")[0]
    }

    if (!url.includes("?") || !idStr) {
      idStr = parts[parts.length - 1]
    }

  }
  if (!idStr || !idStr.length) return

  return idStr
}